// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hr","advertCardFooter__row":"c-a_hs","advertCardFooter__name":"c-a_ht","advertCardFooter__price":"c-a_hu","advertCardFooter__age":"c-a_hv"};